import React from 'react';
import './Job1.css';
import { Container } from 'react-bootstrap';
import Footer from './Footer';

const Job1 = () => {
    return (
        <>
        <div style={{textAlign:'justify'}}>
            <br/><br/>
            <Container>
            <h2>HR Job Description</h2>
            <p>Join our team as an HR professional and play a key role in hiring and managing graphic designers and campus ambassadors. You will be responsible for recruiting new talent, monitoring their work, reporting to senior management, and maintaining performance records.</p>

            <br/>
            <h3>Responsibilities:</h3>
            <ul>
                <li className='points_rem'>Recruit and hire graphic designers and campus ambassadors based on organizational needs.</li>
                <li className='points_rem'>Monitor the performance and work quality of hired personnel.</li>
                <li className='points_rem'>Report the progress and performance of team members to senior management</li>
                <li className='points_rem'>Coordinate with other departments to ensure smooth functioning of the recruitment process.</li>
                <li className='points_rem'>Maintain records of applicant performance and feedback.</li>
                <li className='points_rem'>Provide support and guidance to team members as needed.</li>
            </ul>

            <br/>

            <h3>Requirements:</h3>
            <ul>
                <li className='points_rem'>Excellent communication and interpersonal skills.</li>
                <li className='points_rem'>Strong organizational and time management abilities.</li>
                <li className='points_rem'>Ability to work well under pressure and meet deadlines.</li>

            </ul>

            <br/>

            <h3>Perks:</h3>
            <ul>
                <li className='points_rem'>Opportunity to work in a dynamic and fast-growing educational organization.</li>
                <li className='points_rem'>Competitive salary and benefits package.</li>
                <li className='points_rem'>Professional development and growth opportunities.</li>
                <li className='points_rem'>Flexible work environment with remote work options.</li>
                <li className='points_rem'>Certificate of completion provided upon successful internship completion</li>
                <li className='points_rem'>Stipend: Unpaid</li>
            </ul>
            <br/>

            <p>Send your Resume on <a href="mailto:quicklearn-rtu@gmail.com">email</a></p>
            </Container>

            <hr/>
            <Footer/>
        </div>
        </>
    );
}

export default Job1;
